import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from './utils/axios';
import store from './store';
Vue.prototype.$axios = axios;  // 将 Axios 实例挂载到 Vue 原型上
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '默认标题';
  next();
});
Vue.use(ElementUI,{size:'small'});
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
